const local = "http://localhost:5000";
const live = window.location.origin;

// const API_BASE_URL = live + "/api/v1";
// const API_URL = live;

const API_BASE_URL = "https://closecall.in" + "/corpbiz-call-api/api/v1";
const API_URL = "https://closecall.in" + "/corpbiz-call-api";
export { API_BASE_URL, API_URL };
